import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { OrderModel } from "../models/order";
import { NOTIFICATION_ORDER_ID } from "../constants/message";

interface NotificationInterface {
  data: OrderModel;
  newOrderId: string[];
  count: number;
  ringing: boolean;
  muted: boolean;
}

const initialState: NotificationInterface = {
  data: null!,
  newOrderId: localStorage.getItem(NOTIFICATION_ORDER_ID)
    ? JSON.parse(localStorage.getItem(NOTIFICATION_ORDER_ID) || "[]")
    : [],
  count: 0,
  ringing: false,
  muted: true,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    increaseNotification: (
      state: NotificationInterface,
      action: PayloadAction<OrderModel>
    ) => {
      state.data = action?.payload;
      const newOrderIdValue: string[] = [
        ...state?.newOrderId,
        action?.payload?.id,
      ];
      localStorage.setItem(
        NOTIFICATION_ORDER_ID,
        JSON.stringify(newOrderIdValue)
      );
      state.newOrderId = newOrderIdValue;
      state.count = state.count + 1;
    },
    resetNotification: (state: NotificationInterface) => {
      state.data = null!;
      localStorage.removeItem(NOTIFICATION_ORDER_ID);
      state.count = 0;
    },
    removeNewOrderId: (
      state: NotificationInterface,
      action: PayloadAction<string>
    ) => {
      const newOrderIdValue: string[] = state.newOrderId.filter(
        (item) => item !== action.payload
      );
      state.newOrderId = newOrderIdValue;
      localStorage.setItem(
        NOTIFICATION_ORDER_ID,
        JSON.stringify(newOrderIdValue)
      );
      if (state.count > 0) {
        state.count = state.count - 1;
      }
    },
    openSound: (state: NotificationInterface) => {
      state.ringing = true;
    },
    closeSound: (state: NotificationInterface) => {
      state.ringing = false;
    },
    openMuteSound: (state: NotificationInterface) => {
      state.muted = false;
    },
    closeMuteSound: (state: NotificationInterface) => {
      state.muted = true;
    },
  },
});

export const {
  increaseNotification,
  resetNotification,
  removeNewOrderId,
  openSound,
  closeSound,
  openMuteSound,
  closeMuteSound,
} = notificationSlice.actions;
export default notificationSlice.reducer;
